import { render, staticRenderFns } from "./RBDialog.vue?vue&type=template&id=7742dd98&scoped=true&"
import script from "./RBDialog.vue?vue&type=script&lang=js&"
export * from "./RBDialog.vue?vue&type=script&lang=js&"
import style0 from "./RBDialog.vue?vue&type=style&index=0&id=7742dd98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7742dd98",
  null
  
)

export default component.exports